export default "__VITE_ASSET__BIonKLd8__"